import React from 'react'

const ProjectsInProgress = () => {
  return (
    <div>
      <h3>Plan to support 200 women households</h3>
      <p>
        We have a plan to support 200 women houseolds to enable them to support themseleves in 2025.
      </p>
    </div>
  );
}

export default ProjectsInProgress